import HTML from './html'

export default class GoogleMap {
    constructor() {
        this.defaultZoomLevel = 15
        this.JSAPILoaded = false
        this.JSAPIEmbedded = false
        this.apiKey = 'AIzaSyBWIupwaDqLvfl8lOoq0QTb8cH6xmB5Hko'
        this.style = [
            {
                'featureType': 'landscape',
                'elementType': 'all',
                'stylers': [{ 'color': '#f2f2f2' }],
            },
            {
                'featureType': 'landscape',
                'elementType': 'geometry.fill',
                'stylers': [{ 'lightness': '0' }],
            },
            {
                'featureType': 'landscape.man_made',
                'elementType': 'geometry.fill',
                'stylers': [{ 'visibility': 'on' }, { 'lightness': '-12' }, { 'weight': '2' }],
            },
            {
                'featureType': 'landscape.man_made',
                'elementType': 'geometry.stroke',
                'stylers': [{ 'visibility': 'on' }, { 'lightness': '-47' }, { 'weight': '1' }, { 'color': '#781519' }],
            },
            {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': [{ 'visibility': 'on' }],
            },
            {
                'featureType': 'road',
                'elementType': 'all',
                'stylers': [{ 'saturation': -100 }, { 'lightness': 45 }],
            },
            {
                'featureType': 'road.highway',
                'elementType': 'all',
                'stylers': [{ 'visibility': 'simplified' }],
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'labels.icon',
                'stylers': [{ 'visibility': 'off' }],
            },
            {
                'featureType': 'transit',
                'elementType': 'all',
                'stylers': [{ 'visibility': 'off' }],
            },
            {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': [{ 'color': '#306384' }, { 'visibility': 'on' }],
            },
            {
                'featureType': 'water',
                'elementType': 'geometry.fill',
                'stylers': [{ 'color': '#306384' }],
            },
        ]
        this.projektIcon = `${window.wpEnvironment.templateUrl}/assets/images/project-marker.png`
    }

    /**
     * Initializes map and its dependencies
     */
    loadAssetsAsync(callback) {
        if (!this.JSAPILoaded && (typeof google === 'undefined' || typeof google.maps === 'undefined')) {
            if (this.JSAPIEmbedded) {
                return
            }
            let script = HTML('script')
                .attr({ src: 'https://maps.googleapis.com/maps/api/js?key=' + this.apiKey })
                .on('load', () => {
                    this.JSAPILoaded = true
                    if (typeof callback === 'function') {
                        callback()
                    }
                }).render()
            window.document.body.appendChild(script)
            this.JSAPIEmbedded = true
        } else {
            this.JSAPILoaded = true
            this.JSAPIEmbedded = true
            if (typeof callback === 'function') {
                callback()
            }
        }
        return this
    }
}
